import { getDynamicTextFromSearch } from 'helpers/getDynamicTextFromSearch'

import type { TDynamicTextsFromSearch } from 'models/common.model'

import {
  HEADLINE_QUERY_PARAM,
  PLAN_QUERY_PARAM,
  SUBTEXT_QUERY_PARAM,
} from 'root-constants'

const HEADLINE_MAX_LENGTH = 80
const SUBTEXT_MAX_LENGTH = 100
const PLAN_MAX_LENGTH = 70

export const getDynamicTextsFromSearch = (
  search: string,
): TDynamicTextsFromSearch => ({
  headline: getDynamicTextFromSearch(
    search,
    HEADLINE_QUERY_PARAM,
    HEADLINE_MAX_LENGTH,
  ),
  subtext: getDynamicTextFromSearch(
    search,
    SUBTEXT_QUERY_PARAM,
    SUBTEXT_MAX_LENGTH,
  ),
  plan: getDynamicTextFromSearch(search, PLAN_QUERY_PARAM, PLAN_MAX_LENGTH),
})
